import roles from './roles';

import { ROUTE_PATHS } from 'common/utils/constant';
import EpidemiologyManagement from 'extends/Epidemiology';
import ExternalManagerManagement from 'extends/ExternalManager';
import ExternalManagerDetail from 'extends/ExternalManager/detail';
import ExternalResultManagement from 'extends/ExternalResultManagement';
import SurveyExternalQuestionDetail from 'extends/ExternalResultManagement/detail';
import KioskDetail from 'extends/KioskDetail';
import KioskGroupManagement from 'extends/KioskGroup';
import KioskGroupDetail from 'extends/KioskGroupDetail';
import KioskManagement from 'extends/KioskManagement';
import RatingCounter from 'extends/RatingCounter';
import ReportsManagement from 'extends/ReportsManagement';
import RiskHeartManagement from 'extends/RiskHeartManagement';
import RiskOverviewManagement from 'extends/RiskOverview';
import RiskRenalManagement from 'extends/RiskRenalManagement';
import SurveyQuestionDetail from 'extends/SurveyQuestionDetail';
import SurveyQuestionManagement from 'extends/SurveyQuestionManagement';
import SurveyResultDetail from 'extends/SurveyResultDetail';
import SurveyResultManagement from 'extends/SurveyResultManagement';
import TrackingManagement from 'extends/TrackingManagement';
import ActivityLogsManagement from 'features/ActivityLogsManagement';
import BannerManagement from 'features/BannerManagement';
import CMSTranslationsManagement from 'features/CMSTranslationsManagement';
import EditBanner from 'features/EditBanner';
import EditMenu from 'features/EditMenu';
import EditPageTemplate from 'features/EditPageTemplate';
import EditStaticBlocks from 'features/EditStaticBlocks';
// import ErrorsManagement from 'features/ErrorsManagement';
import FETranslationsManagement from 'features/FETranslationsManagement';
import FilesManagement from 'features/FilesManagement';
import MenuManagement from 'features/MenuManagement';
import PageManagement from 'features/PageManagement';
import PageTemplate from 'features/PageTemplate';
import RedirectImport from 'features/RedirectImport';
// import RedirectManagement from 'features/RedirectManagement';
import RoleDetail from 'features/RoleDetail';
import RoleManagement from 'features/RoleManagement';
import StaticBlockManagement from 'features/StaticBlockManagement';
import SystemConfigsManagement from 'features/SystemConfigsManagement';
import SystemManagement from 'features/SystemManagement';
import UserDetail from 'features/UserDetail';
import UserManagement from 'features/UserManagement';

export type RolesRoute = {
  index?: string;
  create?: string;
  update?: string;
  delete?: string;
  view?: string;
  other?: string[];
};

type RouteProps = {
  id: number;
  name: string;
  path: string;
  element: React.FC<ActiveRoles>;
  roles?: RolesRoute;
  accessRoute?: boolean;
};

const routes: RouteProps[] = [
  {
    id: 1,
    name: 'Page Template',
    path: ROUTE_PATHS.PAGE_TEMPLATE_MANAGEMENT,
    element: PageTemplate,
    roles: {
      index: roles.TEMPLATE_INDEX,
      update: roles.TEMPLATE_UPDATE
    }
  },
  {
    id: 2,
    name: 'Page Management',
    path: ROUTE_PATHS.PAGE_MANAGEMENT,
    element: PageManagement,
    roles: {
      index: roles.PAGE_INDEX,
      create: roles.PAGE_STORE,
      update: roles.PAGE_UPDATE,
      delete: roles.PAGE_DESTROY,
      other: [
        roles.PAGE_APPROVED,
        roles.PAGE_COMMENT_INDEX,
        roles.PAGE_COMMENT_STORE,
      ]
    }
  },
  {
    id: 3,
    name: 'Page Detail',
    path: ROUTE_PATHS.PAGE_DETAIL,
    element: EditPageTemplate,
    roles: {
      index: roles.PAGE_INDEX,
      create: roles.PAGE_STORE,
      update: roles.PAGE_UPDATE,
      other: [roles.PAGE_APPROVED]
    }
  },
  {
    id: 4,
    name: 'Files Management',
    path: ROUTE_PATHS.FILE_MANAGEMENT,
    element: FilesManagement,
    roles: {
      index: roles.FOLDER_VIEWALL,
      other: [
        roles.FOLDER_STORE,
        roles.FOLDER_UPDATE,
        roles.FOLDER_DESTROY,
        roles.FOLDER_GETITEMS,
        roles.FILE_DESTROY,
        roles.FILE_UPDATE,
        roles.FILE_UPLOAD,
        roles.TRASH_EMPTY,
        roles.TRASH_INDEX,
        roles.TRASH_RESTORE,
        roles.TRASH_FORCEDELETE,
      ]
    }
  },
  {
    id: 5,
    name: 'Menu Management',
    path: ROUTE_PATHS.MENU_MANAGEMENT,
    element: MenuManagement,
    roles: {
      index: roles.MENU_INDEX,
      create: roles.MENU_STORE,
      update: roles.MENU_MANAGE,
      delete: roles.MENU_DESTROY
    }
  },
  {
    id: 6,
    name: 'Menu Detail',
    path: ROUTE_PATHS.MENU_DETAIL,
    element: EditMenu,
    roles: {
      index: roles.MENU_INDEX,
      create: roles.MENU_STORE,
      update: roles.MENU_MANAGE,
      delete: roles.MENU_DESTROY
    }
  },
  // {
  //   id: 7,
  //   name: 'News Management',
  //   path: ROUTE_PATHS.NEWS_MANAGEMENT,
  //   element: NewsManagement,
  //   roles: {
  //     index: roles.NEWS_INDEX,
  //     create: roles.NEWS_STORE,
  //     update: roles.NEWS_UPDATE,
  //     delete: roles.NEWS_DESTROY
  //   }
  // },
  // {
  //   id: 8,
  //   name: 'News Detail',
  //   path: ROUTE_PATHS.NEWS_DETAIL,
  //   element: EditNews,
  //   roles: {
  //     index: roles.NEWS_INDEX,
  //     update: roles.NEWS_UPDATE,
  //     create: roles.NEWS_STORE,
  //     other: [roles.NEWS_APPROVED]
  //   }
  // },
  // {
  //   id: 9,
  //   name: 'News Category Management',
  //   path: ROUTE_PATHS.NEWS_CATEGORY_MANAGEMENT,
  //   element: NewsCategoryManagement,
  //   roles: {
  //     index: roles.NEWS_CATE_INDEX,
  //     create: roles.NEWS_CATE_STORE,
  //     delete: roles.NEWS_CATE_DESTROY,
  //     update: roles.NEWS_CATE_UPDATE
  //   }
  // },
  // {
  //   id: 10,
  //   name: 'News Category Detail',
  //   path: ROUTE_PATHS.NEWS_CATEGORY_DETAIL,
  //   element: EditNewsCategory,
  //   roles: {
  //     index: roles.NEWS_CATE_INDEX,
  //     create: roles.NEWS_CATE_STORE,
  //     update: roles.NEWS_CATE_UPDATE,
  //     other: [roles.NEWS_CATE_APPROVED]
  //   }
  // },
  {
    id: 11,
    name: 'Banner Management',
    path: ROUTE_PATHS.BANNER_MANAGEMENT,
    element: BannerManagement,
    roles: {
      index: roles.BANNER_INDEX,
      create: roles.BANNER_STORE,
      delete: roles.BANNER_DESTROY,
      update: roles.BANNER_UPDATE
    }
  },
  {
    id: 12,
    name: 'Banner Detail',
    path: ROUTE_PATHS.BANNER_DETAIL,
    element: EditBanner,
    roles: {
      index: roles.BANNER_INDEX,
      create: roles.BANNER_STORE,
      update: roles.BANNER_UPDATE,
    }
  },
  {
    id: 13,
    name: 'System Management',
    path: ROUTE_PATHS.SYSTEM_MANAGEMENT,
    element: SystemManagement,
    roles: {
      index: roles.SYSTEM_INDEX,
      other: [
        roles.SYSTEM_INDEX,
        roles.SYSTEM_STORE,
        roles.SEO_GENERAL_INDEX,
        roles.SEO_GENERAL_STORE,
        roles.SYSTEM_LOCALE_INDEX,
        roles.SYSTEM_LOCALE_STORE
      ]
    }
  },
  {
    id: 14,
    name: 'System Config Management',
    path: ROUTE_PATHS.SYSTEM_CONFIG_MANAGEMENT,
    element: SystemConfigsManagement,
    roles: {
      index: roles.CONFIG_HEADER_INDEX || roles.CONFIG_FOOTER_INDEX,
      other: [
        roles.CONFIG_HEADER_STORE,
        roles.CONFIG_FOOTER_STORE,
      ]
    }
  },
  {
    id: 16,
    name: 'FE Translation Management',
    path: ROUTE_PATHS.FE_TRANSLATION_MANAGEMENT,
    element: FETranslationsManagement,
    roles: {
      index: roles.FE_TRANSLATION_INDEX,
      create: roles.FE_TRANSLATION_STORE,
      delete: roles.FE_TRANSLATION_DESTROY,
      update: roles.FE_TRANSLATION_UPDATE
    }
  },
  {
    id: 17,
    name: 'CMS Translation Management',
    path: ROUTE_PATHS.CMS_TRANSLATION_MANAGEMENT,
    element: CMSTranslationsManagement,
    roles: {
      index: roles.CMS_TRANSLATION_INDEX,
      create: roles.CMS_TRANSLATION_STORE,
      delete: roles.CMS_TRANSLATION_DESTROY,
      update: roles.CMS_TRANSLATION_UPDATE
    }
  },
  // {
  //   id: 18,
  //   name: 'Redirect Management',
  //   path: ROUTE_PATHS.REDIRECT_MANAGEMENT,
  //   element: RedirectManagement,
  //   roles: {
  //     index: roles.REDIRECT_INDEX,
  //     create: roles.REDIRECT_STORE,
  //     update: roles.REDIRECT_UPDATE,
  //     delete: roles.REDIRECT_DESTROY,
  //   }
  // },
  {
    id: 19,
    name: 'Redirect Import',
    path: ROUTE_PATHS.REDIRECT_IMPORT,
    element: RedirectImport,
    roles: {
      index: roles.REDIRECT_IMPORT,
    }
  },
  {
    id: 20,
    name: 'Activity Logs',
    path: ROUTE_PATHS.ACTIVITY_MANAGEMENT,
    element: ActivityLogsManagement,
    roles: {
      index: roles.ACTIVITYLOG_INDEX
    }
  },
  {
    id: 21,
    name: 'Roles Management',
    path: ROUTE_PATHS.ROLES_MANAGEMENT,
    element: RoleManagement,
  },
  {
    id: 22,
    name: 'Roles Detail',
    path: ROUTE_PATHS.ROLES_DETAIL,
    element: RoleDetail,
  },
  {
    id: 23,
    name: 'User Management',
    path: ROUTE_PATHS.USERS_MANAGEMENT,
    element: UserManagement,
  },
  {
    id: 23,
    name: 'User Detail',
    path: ROUTE_PATHS.USERS_DETAIL,
    element: UserDetail,
  },
  // {
  //   id: 24,
  //   name: 'Faq Management',
  //   path: ROUTE_PATHS.FAQ_MANAGEMENT,
  //   element: FaqManagement,
  //   roles: {
  //     index: roles.FAQ_INDEX,
  //     create: roles.FAQ_STORE,
  //     update: roles.FAQ_UPDATE,
  //     delete: roles.FAQ_DESTROY
  //   }
  // },
  // {
  //   id: 25,
  //   name: 'Edit Faq',
  //   path: ROUTE_PATHS.FAQ_DETAIL,
  //   element: EditFaq,
  //   roles: {
  //     index: roles.FAQ_INDEX,
  //     update: roles.FAQ_UPDATE,
  //     create: roles.FAQ_STORE,
  //     other: [roles.FAQ_APPROVED]
  //   }
  // },
  // {
  //   id: 26,
  //   name: 'CategoriesFaq',
  //   path: ROUTE_PATHS.FAQ_CATEGORY_MANAGEMENT,
  //   element: CategoryFaq,
  //   roles: {
  //     index: roles.FAQ_CATEGORY_INDEX,
  //     create: roles.FAQ_CATEGORY_STORE,
  //     update: roles.FAQ_CATEGORY_UPDATE,
  //     delete: roles.FAQ_CATEGORY_DESTROY
  //   }
  // },
  // {
  //   id: 27,
  //   name: 'EditCategoryFaq',
  //   path: ROUTE_PATHS.FAQ_CATEGORY_DETAIL,
  //   element: EditCategoryFaq,
  //   roles: {
  //     index: roles.FAQ_CATEGORY_INDEX,
  //     update: roles.FAQ_CATEGORY_UPDATE,
  //     create: roles.FAQ_CATEGORY_STORE,
  //     other: [roles.FAQ_CATEGORY_APPROVED]
  //   }
  // },
  // {
  //   id: 28,
  //   name: 'ErrorsManagement',
  //   path: ROUTE_PATHS.ERRORS_MANAGEMENT,
  //   element: ErrorsManagement,
  //   roles: {
  //     index: roles.ERROR_PAGE_404
  //   }
  // },
  // {
  //   id: 29,
  //   name: 'ContactManagement',
  //   path: ROUTE_PATHS.CONTACT_MANAGEMENT,
  //   element: ContactManagement,
  //   roles: {
  //     index: roles.CONTACT_INDEX,
  //     update: roles.CONTACT_UPDATE,
  //     delete: roles.CONTACT_DESTROY,
  //   }
  // },
  // {
  //   id: 30,
  //   name: 'ContactProblemManagement',
  //   path: ROUTE_PATHS.CONTACT_PROBLEM_MANAGEMENT,
  //   element: ContactProblemManagement,
  //   roles: {
  //     index: roles.CONTACT_PROBLEM_INDEX,
  //     create: roles.CONTACT_PROBLEM_STORE,
  //     update: roles.CONTACT_PROBLEM_UPDATE,
  //     delete: roles.CONTACT_PROBLEM_DESTROY
  //   }
  // },
  // {
  //   id: 31,
  //   name: 'ContactProblemDetail',
  //   path: ROUTE_PATHS.CONTACT_PROBLEM_DETAIL,
  //   element: ContactProblemDetail,
  //   roles: {
  //     index: roles.CONTACT_PROBLEM_INDEX,
  //     update: roles.CONTACT_PROBLEM_UPDATE,
  //     create: roles.CONTACT_PROBLEM_STORE,
  //     other: [roles.CONTACT_PROBLEM_APPROVED]
  //   }
  // },
  // {
  //   id: 32,
  //   name: 'EmailTemplateManagement',
  //   path: ROUTE_PATHS.EMAIL_TEMPLATE_MANAGEMENT,
  //   element: EmailTemplateManagement,
  //   roles: {
  //     index: roles.EMAIL_TEMPLATE_INDEX,
  //     update: roles.EMAIL_TEMPLATE_UPDATE,
  //   }
  // },
  // {
  //   id: 33,
  //   name: 'EmailTemplateDetail',
  //   path: ROUTE_PATHS.EMAIL_TEMPLATE_DETAIL,
  //   element: EmailTemplateDetail,
  //   roles: {
  //     index: roles.EMAIL_TEMPLATE_INDEX,
  //     update: roles.EMAIL_TEMPLATE_UPDATE,
  //   }
  // },
  // {
  //   id: 34,
  //   name: 'FormManagement',
  //   path: ROUTE_PATHS.FORM_MANAGEMENT,
  //   element: FormManagement,
  //   roles: {
  //     index: roles.FORM_INDEX,
  //     create: roles.FORM_STORE,
  //     update: roles.FORM_UPDATE,
  //     delete: roles.FORM_DESTROY
  //   }
  // },
  // {
  //   id: 35,
  //   name: 'FormDetail',
  //   path: ROUTE_PATHS.FORM_DETAIL,
  //   element: FormDetail,
  //   roles: {
  //     index: roles.FORM_INDEX,
  //     update: roles.FORM_UPDATE,
  //     create: roles.FORM_STORE,
  //   }
  // },
  {
    id: 36,
    name: 'StaticBlockManagement',
    path: ROUTE_PATHS.STATIC_BLOCK_MANAGEMENT,
    element: StaticBlockManagement,
    roles: {
      index: roles.STATIC_BLOCK_INDEX,
      update: roles.STATIC_BLOCK_UPDATE,
      create: roles.STATIC_BLOCK_STORE,
      delete: roles.STATIC_BLOCK_DESTROY
    }
  },
  {
    id: 37,
    name: 'StaticBlockDetail',
    path: ROUTE_PATHS.STATIC_BLOCK_DETAIL,
    element: EditStaticBlocks,
    roles: {
      index: roles.STATIC_BLOCK_INDEX,
      update: roles.STATIC_BLOCK_UPDATE,
      create: roles.STATIC_BLOCK_STORE
    }
  },
  {
    id: 38,
    name: 'KioskManagement',
    path: ROUTE_PATHS.KIOSK_MANAGEMENT,
    element: KioskManagement,
    roles: {
      index: roles.KIOSK_INDEX,
      create: roles.KIOSK_STORE,
      update: roles.KIOSK_UPDATE,
      delete: roles.KIOSK_DESTROY,
    }
  },
  {
    id: 39,
    name: 'KioskDetail',
    path: ROUTE_PATHS.KIOSK_DETAIL,
    element: KioskDetail,
    roles: {
      index: roles.KIOSK_INDEX,
      create: roles.KIOSK_STORE,
      update: roles.KIOSK_UPDATE,
      delete: roles.KIOSK_DESTROY,
    }
  },
  {
    id: 40,
    name: 'SurveyQuestionManagement',
    path: ROUTE_PATHS.SURVEY_QUESTION_MANAGEMENT,
    element: SurveyQuestionManagement,
    roles: {
      index: roles.QUESTION_INDEX,
      update: roles.QUESTION_UPDATE,
    }
  },
  {
    id: 41,
    name: 'SurveyQuestionDetail',
    path: ROUTE_PATHS.SURVEY_QUESTION_DETAIL,
    element: SurveyQuestionDetail,
    roles: {
      index: roles.QUESTION_INDEX,
      update: roles.QUESTION_UPDATE,
    }
  },
  // {
  //   id: 42,
  //   name: 'old-dashboard',
  //   path: ROUTE_PATHS.OLD_DASHBOARD,
  //   element: OldDashboard,
  //   accessRoute: true
  // },
  {
    id: 43,
    name: 'Reports',
    path: ROUTE_PATHS.REPORTS_MANAGEMENT,
    element: ReportsManagement,
    accessRoute: true
  },
  {
    id: 44,
    name: 'SurveyReport',
    path: ROUTE_PATHS.SURVEY_RESULT_MANAGEMENT,
    element: SurveyResultManagement,
    roles: {
      index: roles.SURVEY_RESULT,
      other: [roles.SURVEY_RESULT_SHOW]
    }
  },
  {
    id: 45,
    name: 'SurveyReportDetail',
    path: ROUTE_PATHS.SURVEY_RESULT_DETAIL,
    element: SurveyResultDetail,
    roles: {
      index: roles.SURVEY_RESULT_SHOW,
    }
  },
  {
    id: 46,
    name: 'KioskGroup',
    path: ROUTE_PATHS.KIOSK_GROUP_MANAGEMENT,
    element: KioskGroupManagement,
    roles: {
      index: roles.KIOSK_GROUP_INDEX,
      create: roles.KIOSK_GROUP_STORE,
      update: roles.KIOSK_GROUP_UPDATE,
      delete: roles.KIOSK_GROUP_DESTROY,
    }
  },
  {
    id: 47,
    name: 'KioskGroupDetail',
    path: ROUTE_PATHS.KIOSK_GROUP_DETAIL,
    element: KioskGroupDetail,
    roles: {
      index: roles.KIOSK_GROUP_INDEX,
      create: roles.KIOSK_GROUP_STORE,
      update: roles.KIOSK_GROUP_UPDATE,
      delete: roles.KIOSK_GROUP_DESTROY,
    }
  },
  {
    id: 49,
    name: 'TrackingManagement',
    path: ROUTE_PATHS.TRACKING_MANAGEMENT,
    element: TrackingManagement,
    roles: {
      index: roles.SURVEY_TRACKING_INDEX,
      other: [roles.SURVEY_TRACKING_EXPORT]
    }
  },
  {
    id: 50,
    name: 'ExternalMannagerManagement',
    path: ROUTE_PATHS.EXTERNAL_MANAGER,
    element: ExternalManagerManagement,
    roles: {
      index: roles.EXTERNAL_MANAGER_INDEX,
      create: roles.EXTERNAL_MANAGER_STORE,
      update: roles.EXTERNAL_MANAGER_UPDATE,
      delete: roles.EXTERNAL_MANAGER_DESTROY,
    }
  },
  {
    id: 51,
    name: 'ExternalMannagerDetail',
    path: ROUTE_PATHS.EXTERNAL_MANAGER_DETAIL,
    element: ExternalManagerDetail,
    roles: {
      index: roles.EXTERNAL_MANAGER_INDEX,
      create: roles.EXTERNAL_MANAGER_STORE,
      update: roles.EXTERNAL_MANAGER_UPDATE,
      delete: roles.EXTERNAL_MANAGER_DESTROY,
    }
  },
  {
    id: 55,
    name: 'healthService-result',
    path: ROUTE_PATHS.HEALTH_SERVICE_RESULT_MANAGEMENT,
    element: ExternalResultManagement,
    roles: {
      index: roles.EXTERNAL_RESULT_INDEX,
    }
  },
  {
    id: 56,
    name: 'healthService-result-detail',
    path: ROUTE_PATHS.HEALTH_SERVICE_RESULT_DETAIL,
    element: SurveyExternalQuestionDetail,
    roles: {
      index: roles.EXTERNAL_RESULT_INDEX,
    }
  },
  {
    id: 59,
    name: 'DashboardManagement',
    path: ROUTE_PATHS.DASHBOARD_MANAGEMENT,
    element: RatingCounter,
    accessRoute: true,
    roles: {
      other: [roles.REPORT_COUNTER_BY_MONTH,
      roles.REPORT_COUNTER_CUMULATIVE_BY_MONTH,
      roles.REPORT_KIOSK_GROUP_REPORT],
    }
  },
  {
    id: 60,
    name: 'EpidemiologyManagement',
    path: ROUTE_PATHS.EPIDEMIOLOGY_MANAGEMENT,
    element: EpidemiologyManagement,
    accessRoute: true,
    roles: {
      other: [roles.REPORT_ANALYTIC],
    }
  },
  {
    id: 61,
    name: 'RiskOverviewManagement',
    path: ROUTE_PATHS.RISK_OVERVIEW_MANAGEMENT,
    element: RiskOverviewManagement,
    accessRoute: true,
    roles: {
      other: [roles.REPORT_KIDNEY_RISK_V3,
      roles.REPORT_HEART_RIS_V3],
    }
  },
  {
    id: 62,
    name: 'RiskHeartManagement',
    path: ROUTE_PATHS.RISK_HEART_MANAGEMENT,
    element: RiskHeartManagement,
    accessRoute: true,
    roles: {
      other: [roles.REPORT_YTNC,
      roles.REPORT_YTNC_BY_HEART_RISK,
      roles.REPORT_ATHEROSCLEROSIS,
      roles.REPORT_YTNC_FOR_ONE_BY_HEART_RISK],
    }
  },
  {
    id: 63,
    name: 'RiskRenalManagement',
    path: ROUTE_PATHS.RISK_RENAL_MANAGEMENT,
    element: RiskRenalManagement,
    accessRoute: true,
    roles: {
      other: [roles.REPORT_KIDNEY_RISK_V3,
      roles.REPORT_ATHEROSCLEROSIS_BY_KIDNEY_RISK,
      roles.REPORT_AGE_BY_KIDNEY_RISK,
      roles.REPORT_YTNC_FOR_ONE_BY_KIDNEY_RISK],
    }
  },
];

export default routes;
